import dayjs from "dayjs";
import {KeyConstant} from "../constant/keyConstant";
import {mapObject} from "./mapObject";
import {t} from "i18next";

export const mapTag = (type, startDate , endDate) => {
    const object = mapObject(type, startDate, endDate)
    let dateDiff = dayjs(object.getEnnDate()).diff(dayjs(object.getStartDate()), 'days') + 1
    switch (type){
        case KeyConstant.TODAY:
            return t("tnp.components.report.dayToday")
        case KeyConstant.YESTERDAY:
            return t("tnp.components.report.dayYesterday")
        case KeyConstant.THIS_WEEK:
            return t("tnp.components.report.oneThisWeek")
        case KeyConstant.LAST_WEEK:
            return t("tnp.components.report.oneWeekAgo")
        case KeyConstant.THIS_MONTH:
            return t("tnp.components.report.oneThisMonth")
        case KeyConstant.LAST_MONTH:
            return  t("tnp.components.report.oneMonthAgo")
        case KeyConstant.SEVEN_DAYS_AGO:
            return  t("tnp.components.report.sevenDayAgo")
        case KeyConstant.THIRTY_DAYS_AGO:
            return  t("tnp.components.report.twentyEightDayAgo")
        case KeyConstant.NINETY_DAYS_AGO:
            return  t("tnp.components.report.ninetyDayAgo")
        default :
            return t("tnp.components.report.numberDay" + ( dateDiff > 1 ? "_plural" : ""), {count: dateDiff})
    }
}
